<template>
  <v-row justify="center">
    <v-dialog v-model="openModal" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeContractModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Contratos</v-toolbar-title>
          <v-spacer></v-spacer>
          <div style="color: #000">
            <v-btn @click="openMessagesDialog" :loading="isMessagesLoading || is_loading" text dark>
              <v-badge
                :content="unreadMessages"
                :value="unreadMessages > 0"
                color="error"
                overlap
                offset-x="10"
                offset-y="10"
              >
                Mensagens
                <v-icon dark right class="mr-2">
                  mdi-message-text
                </v-icon>
              </v-badge>
            </v-btn>

            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  :loading="is_loading"
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-if="!isFranchisee"
                  @click="openNewContractModal(false, null)"
                  :disabled="is_loading"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-file-document-edit</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Novo Contrato</v-list-item-title>
                </v-list-item>

                <v-list-item
                  @click="additionalDataDialog = true"
                  :disabled="is_loading"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-file-document-multiple-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Dados Adicionais</v-list-item-title>
                </v-list-item>

                <v-list-item
                  v-if="!isFranchisee"
                  @click="dialog = true"
                  :disabled="is_loading"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-paperclip</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Documentos</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>

        </v-toolbar>

        <template>
          <ContractList 
            :contracts="contract.requests"
            @edit-contract="handleContractDetails"
          />
        </template>

        <template>
          <NewContractModal
            :open="showNewContractModal"
            ref="newContractModal"
            :close="closeNewContractModal"
            :idContract="idContract"
            @create-contract="handleContractAdd"
            @update-contract="handleContractEdit"
            @contract-generation-started="openContractGenerationModal"
          />
        </template>

        <ProjectMessagesDialog
          v-model="show_messages_dialog"
          :project-id="idProject"
          :loading="is_loading"
          :current-step="currentStep"
          ref="projectMessagesDialog"
          @contract-change-requested="handleContractChangeRequested"
        >
          <template v-if="isFranchisee" v-slot:below-message-input>
            <v-row class="d-flex align-center">
              <v-col cols="6">
                <v-checkbox
                  v-model="requestContractChanging"
                  label="Solicitar Alteração de Contrato"
                  color="primary"
                  hide-details
                ></v-checkbox>
              </v-col>
            </v-row>
          </template>
        </ProjectMessagesDialog>

        <template v-if="!isFranchisee">
          <NextStepProject
            :loading="is_loading"
            :disabled="!enableNextStepButton || isFranchisee"
            :message="buttonMessage"
            :click="openConfirmExpeditionModal"
          />
        </template>
      </v-card>
    </v-dialog>

    <v-dialog v-model="automaticGenerationContractDialog" max-width="600px" persistent>
      <v-col cols="12" style="background-color: #FFF; color: #000;">
        <div style="display: flex; justify-content: space-between; align-items: center; padding: 16px;">
          <span class="text-h4" style="font-weight: 400;">Contratos Automáticos</span>
          <v-btn color="primary" @click="automaticGenerationContractDialog = false">
            Fechar
          </v-btn>
        </div>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="12">
            <v-select
                v-model="selectedTemplate"
                :items="activesTemplatesContracts"
                item-value="id_doc"
                item-text="templateName"
                label="Selecione um Template de Contrato"
                single-line
                return-object
                outlined
                clearable
                dense
                required
                :item-disabled="isTemplateUsed"
            />
            <div class="caption grey--text text--darken-1 mt-n4">
              Templates desabilitados já estão sendo usados em outros contratos.
            </div>
          </v-col>
          <v-col cols="12" style="margin-top: -20px;">
            <v-select
                v-model="selectedProposal"
                :items="rawProposalsData"
                item-value="id_doc"
                :item-text="proposal => mapProposalsType(proposal.typeProposal.type)"
                single-line
                label="Selecione a proposta desejada"
                return-object
                outlined
                clearable
                dense
                required
            />
          </v-col>
          <v-col>
            <v-btn :disabled="!selectedTemplate || !selectedProposal" color="primary" @click="fillCustomAnchors" elevation="2"
                   style="margin-top: -30px;">
              Gerar Contrato
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-dialog>

    <v-dialog v-model="displayCustomAnchorsToFillDialog" :max-width='automateContractData.customAnchors.length ? "1920" : "800"' persistent>
      <v-col cols="12" style="background-color: #FFF; color: #000;">
        <div style="display: flex; justify-content: space-between; align-items: center; padding: 16px;">
          <span class="text-h4" style="font-weight: 400;">{{ automateContractData.customAnchors.length ? 'Preenchimento de Âncoras Customizadas' : 'Conferência dos dados' }}</span>
          <div>
            <v-btn style="margin-right: 15px;" color="primary" :disabled="isLoadingDocx || isLoadingPdf" @click="chooseAnotherTemplate">
              Alterar Template
            </v-btn>

            <v-btn color="primary" :disabled="isLoadingDocx || isLoadingPdf" @click="displayCustomAnchorsToFillDialog = false">
              Fechar
            </v-btn>
          </div>
        </div>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="12">
            <div style="display: grid; grid-template-columns: auto 1fr; gap: 10px;">
              <span><strong>Nome do Template:</strong></span>
              <span>{{ selectedTemplate && selectedTemplate.templateName ? selectedTemplate.templateName : '' }}</span>
            </div>
          </v-col>
          <v-col cols="12">
            <div style="display: grid; grid-template-columns: auto 1fr; gap: 21px; margin-top: -20px;">
              <span><strong>Nome do Arquivo:</strong></span>
              <span>{{ selectedTemplate && selectedTemplate.fileName ? selectedTemplate.fileName : '' }}</span>
            </div>
          </v-col>
          <v-col cols="12">
            <div style="display: grid; grid-template-columns: auto 1fr; gap: 23px; margin-top: -20px;">
              <span><strong>Tipo da Proposta:</strong></span>
              <span>{{ selectedProposal && selectedProposal.typeProposal.type ? mapProposalsType(selectedProposal.typeProposal.type) : '' }}</span>
            </div>
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-row>
          <v-col v-for="(anchor, index) in automateContractData.customAnchors" :key="index" cols="4">
            <v-text-field
                v-model="anchor.value"
                :label="anchor.name"
                outlined
            />
          </v-col>
        </v-row>
        <v-row style="margin-top: 20px;">
          <v-spacer></v-spacer>
          <v-btn
              color="primary"
              type="submit"
              elevation="2"
              style="margin-left: 10px"
              :disabled="hasNullValuesInCustomAnchors || isLoadingPdf"
              :loading="isLoadingDocx"
              @click="generateContract(false)"
          >
            Gerar Contrato (DOCX)
          </v-btn>
        </v-row>
      </v-col>
    </v-dialog>

    <v-dialog v-model="additionalDataDialog" max-width="1920px" persistent>
      <v-col cols="12" style="background-color: #FFF; color: #000;">
        <div style="display: flex; justify-content: space-between; align-items: center; padding: 16px;">
          <span class="text-h4" style="font-weight: 400;">Dados Adicionais</span>
          <v-btn color="primary" @click="additionalDataDialog = false">
            Fechar
          </v-btn>
        </div>

        <v-row>
          <v-col cols="12" md="4">
            <v-card 
              class="elevation-3 franchisee-card" 
              :class="{ 'hover-effect': true }"
              style="padding: 20px; border-radius: 16px; background-color: #f9f9f9; transition: all 0.3s ease;"
            >
              <v-card-title class="text-h5 d-flex align-center" style="font-weight: 600; color: #2c3e50;">
                <v-icon color="primary" class="mr-2">mdi-account-tie</v-icon>
                Franqueado
              </v-card-title>
              <v-divider class="my-3"></v-divider>
              <v-card-text style="color: #555;">
                <v-row>
                  <v-col cols="12">
                    <div
                      v-for="(dado, index) in franchiseeData"
                      :key="index"
                      v-if="dado.header !== 'Endereço'"
                      class="data-row"
                      style="margin-bottom: 16px; display: flex; align-items: center; transition: background-color 0.2s ease;"
                    >
                      <strong class="data-label">{{ dado.header }}:</strong>
                      <span class="data-value">{{ dado.value }}</span>
                    </div>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <div v-for="(dado, index) in franchiseeData" :key="index" v-if="dado.header === 'Endereço'">
                      <v-card
                        class="elevation-2 address-card"
                        style="padding: 16px; border-radius: 12px; background-color: #fff; overflow: hidden; transition: transform 0.2s ease;"
                      >
                        <v-card-title class="text-h6 d-flex align-center" style="font-weight: 600; color: #2c3e50;">
                          <v-icon color="primary" class="mr-2">mdi-map-marker</v-icon>
                          {{ dado.header }}
                        </v-card-title>
                        <v-card-text style="color: #555;">
                          <div
                            v-for="(field, fieldKey) in dado.value"
                            :key="fieldKey"
                            class="address-field"
                            style="display: flex; margin-bottom: 12px; transition: background-color 0.2s ease;"
                          >
                            <strong class="field-label">
                              {{ fieldKey }}:
                            </strong>
                            <span class="field-value">
                              {{ field }}
                            </span>
                          </div>
                        </v-card-text>
                      </v-card>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col>
            <v-card 
              class="elevation-3 client-card" 
              :class="{ 'hover-effect': true }"
              style="padding: 20px; border-radius: 16px; background-color: #f9f9f9; transition: all 0.3s ease;"
            >
              <v-card-title class="text-h5 d-flex align-center" style="font-weight: 600; color: #2c3e50;">
                <v-icon color="primary" class="mr-2">mdi-account</v-icon>
                Cliente
              </v-card-title>
              <v-divider class="my-3"></v-divider>
              <v-card-text style="color: #555;">
                <v-row>
                  <v-col cols="12">
                    <div
                      v-for="(client, index) in clientData"
                      :key="index"
                      v-if="client.header !== 'Endereço' && client.header !== 'Responsável'"
                      class="data-row"
                      style="margin-bottom: 16px; display: flex; align-items: center; transition: background-color 0.2s ease;"
                    >
                      <strong class="data-label">{{ client.header }}:</strong>
                      <span class="data-value">{{ client.value }}</span>
                    </div>
                  </v-col>
                </v-row>

                <v-row style="align-items: stretch;">
                  <v-col cols="12" md="6" v-if="clientData.some(item => item.header === 'Endereço')">
                    <v-card
                      class="elevation-2 info-card"
                      style="padding: 16px; border-radius: 12px; background-color: #fff; height: 100%; transition: transform 0.2s ease;"
                    >
                      <v-card-title class="text-h6 d-flex align-center" style="font-weight: 600; color: #2c3e50;">
                        <v-icon color="primary" class="mr-2">mdi-map-marker</v-icon>
                        Endereço
                      </v-card-title>
                      <v-card-text>
                        <div
                          v-for="(dado, index) in clientData"
                          :key="'endereco-' + index"
                          v-if="dado.header === 'Endereço'"
                          class="info-section"
                        >
                          <div v-for="(field, fieldKey) in dado.value" :key="fieldKey" class="info-field">
                            <strong class="field-label">
                              {{ fieldKey }}:
                            </strong>
                            <span class="field-value">
                              {{ field }}
                            </span>
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="6" v-if="clientData.some(item => item.header === 'Responsável')">
                    <v-card
                      class="elevation-2 info-card"
                      style="padding: 16px; border-radius: 12px; background-color: #fff; height: 100%; transition: transform 0.2s ease;"
                    >
                      <v-card-title class="text-h6 d-flex align-center" style="font-weight: 600; color: #2c3e50;">
                        <v-icon color="primary" class="mr-2">mdi-account-tie</v-icon>
                        Responsável
                      </v-card-title>
                      <v-card-text>
                        <div
                          v-for="(dado, index) in clientData"
                          :key="'responsavel-' + index"
                          v-if="dado.header === 'Responsável'"
                          class="info-section"
                        >
                          <div v-for="(field, fieldKey) in dado.value" :key="fieldKey" class="info-field">
                            <strong class="field-label">
                              {{ fieldKey }}:
                            </strong>
                            <span class="field-value">
                              {{ field }}
                            </span>
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-card 
              class="elevation-3 contract-observations-card" 
              :class="{ 'has-observations': contract.observations }"
            >
              <v-card-title class="d-flex align-center">
                <v-icon 
                  color="primary" 
                  class="mr-2"
                  size="24"
                >
                  mdi-text-box-outline
                </v-icon>
                <span class="text-h5 font-weight-medium">Observações do Contrato</span>
              </v-card-title>
              
              <v-divider class="my-3"></v-divider>
              
              <v-card-text>
                <transition name="fade">
                  <div
                    v-if="contract.observations"
                    class="observations-content"
                    role="region"
                    aria-label="Observações do contrato"
                  >
                    {{ contract.observations }}
                  </div>
                  <div 
                    v-else 
                    class="no-observations"
                    role="status"
                    aria-label="Nenhuma observação disponível"
                  >
                    <v-icon
                      color="grey lighten-1"
                      size="48"
                      class="mb-2"
                    >
                      mdi-text-box-remove-outline
                    </v-icon>
                    <span>Nenhuma observação disponível.</span>
                  </div>
                </transition>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-card class="elevation-3" style="padding: 16px; border-radius: 12px; background-color: #f9f9f9;">
              <v-card-title class="text-h5" style="font-weight: 500; color: #333;">
                <span class="text-h5" style="font-weight: 400;">Propostas Solicitadas</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-data-table
                  :items="proposalsData"
                  :headers="proposalsTableHeader"
                  class="elevation-1"
                  style="padding: 16px; border-radius: 10px; background-color: #fff; height: 100%;"
                >
                  <template v-slot:body="{ items }">
                    <tr v-for="(item, index) in items" :key="index">
                      <td style="margin-left: -30px;">{{ item.proposalType }}</td>
                      <td>{{ item.referenceAverage }}</td>
                      <td>{{ item.referenceAverageWater }}</td>
                      <td>{{ item.referenceAverageSewer }}</td>
                      <td>{{ item.totalInvestment }}</td>
                      <td>
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn elevation="2" v-bind="attrs" v-on="on" :loading="idProposalPDF === item.id_doc">
                              <v-icon color="primary">
                                mdi-file-pdf-box
                              </v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item
                              v-for="(menuItem, index) in itemsMenuPDF"
                              :key="index"
                              link
                              @click="pdfRequest(item.id_doc, menuItem.value)"
                            >
                              <v-list-item-title>{{ menuItem.title }}</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
                </v-card-text>
                <v-dialog v-model="dialogDownload" max-width="400">
                  <v-card class="download-dialog">
                  <v-card-title class="headline d-flex align-center">
                    <v-icon color="primary" class="mr-2">mdi-download</v-icon>
                    Salvar Arquivo
                  </v-card-title>
                  <v-card-text class="pt-4">
                    <p class="text-body-1">
                      O arquivo está pronto para ser baixado. Clique no botão abaixo para salvá-lo em seu computador.
                    </p>
                    <v-alert
                      type="info"
                      variant="tonal"
                      class="mt-3"
                      icon="mdi-information"
                    >
                      Após o download, esta janela fechará automaticamente.
                    </v-alert>
                  </v-card-text>
                  <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <a :href="fileLink" download class="text-decoration-none">
                      <v-btn
                        color="primary"
                        variant="elevated"
                        prepend-icon="mdi-download"
                        @click="dialogDownload = false"
                      >
                        Salvar Arquivo
                      </v-btn>
                    </a>
                    <v-btn
                      color="white"
                      variant="text"
                      class="ml-2"
                      @click="dialogDownload = false"
                    >
                      Fechar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-dialog>

    <v-dialog v-model="confirmExpeditionModal" max-width="500">
      <v-card>
        <v-card-title>
          <span class="text-h6">Confirmação</span>
        </v-card-title>
        <v-card-text>
          <v-checkbox
            v-model="contract.clientSideSignedContract"
            label="Confirmar que possui o contrato com a assinatura do Cliente"
          />
          <v-checkbox
            v-model="contract.franchiseeSideSignedContract"
            label="Confirmar que possui o contrato com a assinatura do Franqueado"
          />
          <v-checkbox
            v-model="contract.companySideSignedContract"
            label="Confirmar que possui o contrato com a assinatura da Matriz"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="confirmExpeditionModal = false">Fechar</v-btn>
          <v-btn text @click="activateExpedition">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title>
          <span class="text-h6">Documentos Auxiliares</span>
        </v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item v-for="(doc, index) in contract.uploadDocumentsPath" :key="index">
              <v-list-item-content>
                <v-list-item-title>{{ doc.name }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn :loading="is_loading" icon @click="downloadDocument(doc.url)">
                  <v-icon color="primary" >mdi-download</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialog = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import Contract from './Contract.js';
export default Contract;
</script>

<style scoped>
.download-dialog {
  border-radius: 12px;
  overflow: hidden;
}

.v-card-title {
  background: linear-gradient(to right, var(--v-primary-base), var(--v-primary-lighten1));
  color: white;
}

.v-btn {
  text-transform: none;
  letter-spacing: 0.5px;
  font-weight: 500;
}

.v-alert {
  border-radius: 8px;
}

.hover-effect:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
}

.data-row:hover,
.address-field:hover,
.info-field:hover {
  background-color: rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  padding: 4px 8px;
}

.data-label,
.field-label {
  min-width: 140px;
  color: #2c3e50;
  font-weight: 600;
  text-transform: capitalize;
}

.data-value,
.field-value {
  color: #34495e;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  max-width: calc(100% - 140px);
  line-height: 1.5;
}

.info-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-left: 12px;
}

.info-field {
  display: flex;
  padding: 4px 8px;
  border-radius: 8px;
  transition: background-color 0.2s ease;
}

.address-card:hover,
.info-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

@media (max-width: 600px) {
  .data-label,
  .field-label {
    min-width: 120px;
  }
  
  .data-value,
  .field-value {
    max-width: calc(100% - 120px);
  }
}

.contract-observations-card {
  padding: 16px;
  border-radius: 12px;
  background-color: #f9f9f9;
  transition: all 0.3s ease;
}

.contract-observations-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.observations-content {
  max-height: 6rem;
  overflow-y: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  color: #555;
  padding: 8px;
  line-height: 1.5;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
}

.observations-content::-webkit-scrollbar {
  width: 6px;
}

.observations-content::-webkit-scrollbar-track {
  background: transparent;
}

.observations-content::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

.no-observations {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  color: #888;
  font-style: italic;
  text-align: center;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
